module.exports = __webpack_public_path__ + "static/media/mifare_logo.422b04d1.png";